<aside class="sidebar" [class.sidebar--open]="isSidebarOpen">
  <nav class="top-nav">
    <a class="logo" routerLink="/">
      <srm-logo class="sidebar-logo" />
    </a>
    <div class="nav-group nav-group--actions">
      <a routerLink="/" class="menu-icon-text desktop-only" title="Home" aria-label="Home">
        <srm-icon [config]="homeIconConfig" />
      </a>

      <a class="menu-icon-text menu-toggle" (click)="toggleSidebar()" title="Menu" aria-label="Menu">
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g class="icon-hamburger">
            <path
              d="M2 8.47729H30M2 16.9773H30M2 25.4773H30"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>

          <g class="icon-close">
            <path
              d="M7 7L25 25M7 25L25 7"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
        </svg>
      </a>
    </div>
  </nav>

  <nav class="nav-group nav-group--features">
    @if (canViewContractAdvisor) {
      <div class="advisor-nav">
        <a
          routerLink="/advisor"
          routerLinkActive="menu-icon-text--active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="menu-icon-text"
          title="ContractAdvisor"
          aria-label="ContractAdvisor"
        >
          <srm-icon [config]="advisorIconConfig" />
        </a>
        <div class="advisor-subnav">
          <a
            routerLink="/vendors/map"
            routerLinkActive="advisor-subnav__link--active"
            class="advisor-subnav__link"
            title="VendorMap"
            aria-label="VendorMap"
          >
            VendorMap
          </a>
          <a
            routerLink="/services/map"
            routerLinkActive="advisor-subnav__link--active"
            class="advisor-subnav__link"
            title="ServiceMap"
            aria-label="ServiceMap"
          >
            ServiceMap
          </a>
        </div>
      </div>
    }
    @if (canViewTrackers) {
      <a routerLink="/trackers" class="menu-icon-text" title="Trackers" aria-label="Trackers">
        <srm-icon [config]="trackerIconConfig" />
      </a>
    }

    @if (userRole === roles.GlobalAdmin) {
      <a routerLink="/organizations" class="menu-icon-text" title="Organizations" aria-label="Organizations">
        <srm-icon [config]="organizationsIconConfig" />
      </a>
    } @else if (canViewOrganization) {
      <a
        [routerLink]="['/organization', organizationId]"
        class="menu-icon-text"
        title="Organization"
        aria-label="Organization"
      >
        <srm-icon [config]="organizationsIconConfig" />
      </a>
    }
    @if (canViewInvoices) {
      <a routerLink="/invoices" class="menu-icon-text" title="Invoices" aria-label="Invoices">
        <srm-icon [config]="invoicesIconConfig" />
      </a>
    }
    @if (canViewProjects) {
      <a routerLink="/projects" class="menu-icon-text" title="Engagements" aria-label="Engagements">
        <srm-icon [config]="projectsIconConfig" />
      </a>
    }
  </nav>

  <div class="nav-group nav-group--account">
    <a class="menu-icon-text" title="Logout" aria-label="Logout" (click)="onLogout()">
      <srm-icon [config]="logoutIconConfig" />
    </a>
  </div>

  <a class="desktop-menu-close" (click)="toggleSidebar()">
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14 0.25C21.5939 0.25 27.75 6.40609 27.75 14C27.75 21.5939 21.5939 27.75 14 27.75C6.40609 27.75 0.25 21.5939 0.25 14C0.25 6.40609 6.40609 0.25 14 0.25Z"
        stroke="#E0E0E0"
        stroke-width="0.5"
      />
      <path
        d="M16.2222 20.2218L10 13.9996L16.2222 7.77734"
        stroke="white"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </a>
</aside>
